import React from 'react';
import logo from './../../assets/img/favicon-dark.png';
import moment from 'moment';
import { Bar } from "react-chartjs-2";
import { Comment, List } from 'antd';
import $ from 'jquery';
import LZString from 'lz-string';

class PPEAwarenessDailyReport extends React.Component {
    constructor() {
        super();
        this.state = {
            date: moment().format('YYYY-MM-DD'),
            startTime: "",
            endTime: "",
            user: {},
            ppeAwarenessData: [],
            zones: []
        };
        this.location_ids = '';
        this.pdfTitle = 'PPE Awareness Daily Report';
    }

    getPathParams = () => {
        var pathParams = window.location.search;
        pathParams = pathParams.length > 0 ? pathParams.substring(1) : '';
        return pathParams.length > 0 ? JSON.parse(LZString.decompressFromBase64(pathParams)) : {};
    }

    componentDidMount() {
        document.body.style.backgroundColor = '#fff';
        var pdfData = this.getPathParams();
        console.log('pdfData', pdfData);

        this.setState({ user: pdfData, zones: pdfData.zones, date: pdfData.date, startTime: pdfData.startTime, endTime: pdfData.endTime, ppeItemType: pdfData.ppeItemType }, function () {
            this.location_ids = this.state.zones.map(z => {
                if (z.location_config && z.location_config.feature_controls && z.location_config.feature_controls.ppe_awareness) {
                    if (z.location_config.feature_controls.ppe_awareness.enabled === true)
                        return z.location_id;
                    else
                        return null
                }
                return z.location_id;
            }).reduce((prev, curr) => `${prev},${curr}`);

            if (this.state.user.site_selected) {
                this.fetchHumanPower();
            }
        })
    }

    fetchHumanPower = () => {
        var data = {
            customer_id: this.state.user.customer_id,
            site_id: this.state.user.site_selected.site_id,
            user_login: this.state.user.user_login,
            user_token: this.state.user.user_token,
            date: this.state.date,
            location_id: this.location_ids,
            timezone: this.state.user.site_selected.site_iana_timezone,
            is_ppe: true
        }
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/ppe-report',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    var ppeAwarenessData = [];
                    var data = res.data.ppe_report;
                    if (data && data.length > 0) {
                        for (let element of data) {
                            var location_name = this.state.zones.find((zone) => zone.location_id === element.location_id).location_name;
                            element['location_name'] = location_name;
                            if (element.comments.trim() !== "") {
                                element.comments = JSON.parse(element.comments);
                            } else {
                                element.comments = element.comments.trim();
                            }

                            var hr = moment.tz(element.dev_timestamp * 1000, this.state.user.site_selected.site_iana_timezone).format('HH:mm');
                            if (hr >= moment(this.state.startTime, 'hh:mm a').format('HH:mm') && hr <= moment(this.state.endTime, 'hh:mm a').format('HH:mm'))
                                ppeAwarenessData.push(element);
                        };
                    }
                    this.setState({ ppeAwarenessData, data_fetched: true, loading: false });
                }
            })
    }

    setPDFContentReady = () => {
        if (this.state.data_fetched)
            setTimeout(function () { window.status = 'ready'; }, 3000);
    }

    render() {

        var time = [], dataSets = [];

        var sortedZones = this.state.ppeAwarenessData.sort((a, b) => a.dev_timestamp - b.dev_timestamp);
        var filteredZones = [];
        if (this.state.ppeItemType === 'all') {
            filteredZones = sortedZones
        }
        else
            filteredZones = sortedZones.filter((z) => z.class_name === (this.state.ppeItemType === 'hardHat' ? 'HEAD_COVER' : 'HAND_COVER'));

        time = filteredZones.map(z => moment.tz(z.dev_timestamp * 1000, this.state.user.site_selected.site_iana_timezone).format('h:mm a').toUpperCase());
        time = [...new Set(time)];

        var zoneIds = [...new Set(filteredZones.map(z => z.location_id))];
        var stack = 0;
        zoneIds.forEach(zId => {
            var zone = filteredZones.filter(z => z.location_id === zId);
            var label = "";
            var ppeItems = zone.map(z => z.class_name);
            ppeItems = [...new Set(ppeItems)];
            ppeItems.forEach((item) => {
                var color = `rgba(${Math.floor(Math.random() * 255)},${Math.floor(Math.random() * 255)},${Math.floor(Math.random() * 255)},0.9)`;
                var personCount = [];
                var data = zone.filter(z => z.class_name === item);
                time.forEach(t => {
                    var zoneData = data.find(zn => moment.tz(zn.dev_timestamp * 1000, this.state.user.site_selected.site_iana_timezone).format("h:mm a").toUpperCase() === t);
                    if (zoneData) {
                        personCount.push(zoneData.person_count);
                        label = `${zoneData.location_name}(${zoneData.class_name === 'HEAD_COVER' ? 'Hard Hat' : 'Hand Gloves'})`;
                    }
                    else personCount.push(0);
                });
                dataSets.push({ label: label, backgroundColor: color, hoverBackgroundColor: color, data: personCount, stack: stack });
            });
            stack = stack + 1;
        });

        const chart = {
            data: {
                labels: time,
                datasets: dataSets
            },
            options: {
                scales: {
                    xAxes: [{
                        stacked: true,
                        display: true, gridLines: { display: false },
                        scaleLabel: { display: true, labelString: "Time", fontColor: 'orange' },
                        ticks: {
                            beginAtZero: true,
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        display: true, gridLines: { display: false },
                        scaleLabel: { display: true, labelString: "Person Count", fontColor: 'orange' },
                        ticks: {
                            beginAtZero: true,
                            callback: function (value, index, values) {
                                if (Math.round(value) === value) {
                                    return value
                                }
                            }
                        }
                    }]
                },
            }
        }
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12 my-5">
                        <span className="navbar-brand text-primary">
                            <img src={logo} alt="logo" style={{ width: "25px", marginRight: '10px' }} />
                            {"SiteSupt OnDemand"}
                        </span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <h4>{this.pdfTitle}</h4>
                    </div>
                    <div className="col-md-12">
                        <label className="font-weight-bold text-primary">{this.state.user && this.state.user.site_selected && this.state.user.site_selected.site_name}</label>
                        <span>&nbsp;
                            ({this.state.startTime} <i className="fas fa-arrows-alt-h"></i> {this.state.endTime})
                        </span>
                    </div>
                </div>

                <div className="card my-2 bg-shadow">
                    <div className="card-body text-center">
                        {
                            filteredZones.length > 0 ?
                                <React.Fragment>
                                    <Bar data={chart.data} options={chart.options} />
                                </React.Fragment>
                                :
                                "No Data Found ..."
                        }
                    </div>
                </div>

                {filteredZones && filteredZones.length > 0 &&
                    <div className="card bg-shadow mb-2">
                        <div className="card-header bg-primary text-light p-2">Events Summary</div>
                        <div className="card-body text-left">
                            <table className="table table-striped">
                                <tbody>
                                    {filteredZones.map(d => {
                                        let c = d.comments;
                                        let t = Array.isArray(c) && c.map((c1, i) =>
                                            <tr className="col-md-3" key={d.author + '_' + d.datetime + '_' + i}>
                                                <td width="120px" className="text-primary">{moment.tz(d.dev_timestamp * 1000, this.state.user.site_selected.site_iana_timezone).format('hh:mm:ss a').toUpperCase()}</td>
                                                <td width="150px" nowrap >{this.location_map && this.location_map[d.location_id]}</td>
                                                <td>{c1.content}</td>
                                            </tr>
                                        );
                                        return t;
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                }

                <div className="row">
                    {filteredZones.map((zone, index) =>
                        <div key={index} className="col-md-6">
                            <div className="card bg-shadow mt-4 align-print-page">
                                <div className="text-app bg-light p-2">
                                    {zone.location_name.trim() + ", " + moment.tz(zone.dev_timestamp * 1000, this.state.user.site_selected.site_iana_timezone).format('hh:mm:ss a').toUpperCase()}
                                </div>
                                <div className="card-body p-0">
                                    <img className="card-img-top img-fluid d-block" src={zone.image} alt="" />
                                    {zone.comments !== "" && <List
                                        className={"p-2"}
                                        dataSource={zone.comments}
                                        header={'Comments'}
                                        itemLayout="horizontal"
                                        renderItem={items => <li><Comment {...items} /></li>}
                                    />}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {this.setPDFContentReady()}
            </div>
        );
    }
}

export default PPEAwarenessDailyReport;